export default __webpack_public_path__ + "8fc5f5f22c9951113696814563351c8c.woff";